import {
    StyledModal,
    StyledModalBody,
    StyledModalFooter,
    StyledModalHeader,
    StyledModalOverlay,
    StyledModalParagraph,
    StyledModalTitle
} from '@components/ui/modal-atoms/style.ts'
import {ButtonHTMLAttributes, HTMLAttributes} from 'react'
import {Button} from '@components/ui/button/Button.tsx'
import {XCloseIcon} from '@components/ui/icon/Icon.tsx'

export const ModalOverlay = (props: HTMLAttributes<HTMLDivElement>) => <StyledModalOverlay {...props} />
export const Modal = ({width, ...props}: HTMLAttributes<HTMLDivElement> & {width: string}) => (
    <StyledModal $width={width} {...props} />
)
export const ModalHeader = (props: HTMLAttributes<HTMLDivElement>) => <StyledModalHeader {...props} />
export const ModalBody = (props: HTMLAttributes<HTMLDivElement>) => <StyledModalBody {...props} />
export const ModalFooter = (props: HTMLAttributes<HTMLDivElement>) => <StyledModalFooter {...props} />
export const ModalTitle = (props: HTMLAttributes<HTMLHeadingElement>) => <StyledModalTitle {...props} />
export const ModalParagraph = (props: HTMLAttributes<HTMLParagraphElement>) => <StyledModalParagraph {...props} />
export const ModalXCloseButton = (props: ButtonHTMLAttributes<HTMLButtonElement>) => (
    <Button variant="ghost" size="sm" shape="square" {...props}>
        <XCloseIcon />
    </Button>
)
